import * as React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

import { PostsData } from "../../utils/PostsData";
// import { Tab } from "../../pages/tab";// TODO: Remove tab
import { Filter } from "./Filter";
import { FilterUtils, useIsDesktop } from "./FilterUtils";
import { LibraryUtils } from "../LibraryContainer/LibraryUtils";
import { PostLib } from "../LibraryContainer/PostLib";


let hash_message = {
    "rdkfilter": window.location.hash,
    "rdkinfo": window.location.search,
};
window.addEventListener("message", (event) => {
    if (!window.Settings.LOCAL_BUILD) {
        if(event.data.hasOwnProperty("rdkfilter")) {
            hash_message = {
                "rdkfilter": event.data.rdkfilter,
                "rdkinfo": event.data.rdkinfo
            }
        }
    }
});

// Init on message for url filters
let tickApplyFilter = null;

// Default brand, type, axes filters
let brandFilter: stringBoolMap = {};
Object.keys(PostsData.ListAllBrands).forEach(brand => {
    brandFilter[brand] = false
});

let controllerFilter: stringBoolMap = {};
Object.keys(PostsData.ListAllControllers).forEach(controller => {
    controllerFilter[controller] = false
});

let extensionFilter: stringBoolMap = {};
Object.keys(PostsData.ListAllExtensions).forEach(extension => {
    extensionFilter[extension] = false
});

// Flag to hide tab
const hideTab = window.location.search.includes("HideTab");


export const PostFilter = () => {
    const { t, i18n } = useTranslation();

    // Init state
    const [init, setInit] = React.useState(true);

    // Filter states
    const [brands, setBrands] = React.useState(brandFilter);
    const [controllers, setControllers] = React.useState(controllerFilter);
    const [extensions, setExtensions] = React.useState(extensionFilter);

    const [sortFilteredPosts, setSortFilteredPosts] = React.useState(PostsData.DATA_ALL);

    // Filter helper states
    const [filterType, setFilterType] = React.useState("instant");
    const [noRobotsMessage, setNoRobotsMessage] = React.useState("");

    // Helper variables
    let filteredPostsCounts = FilterUtils.countCheckboxParameters("post", sortFilteredPosts);

    const parameters = {
        "brands": brands,
        "controllers": controllers,
        "extensions": extensions,
    };

    const setupFilter = (url_data: any) => {
        const default_filter_map = {
            "brand": brandFilter,
            "controller": controllerFilter,
            "extension": extensionFilter,
        };
        const filter_set_map = {
            "brand": setBrands,
            "controller": setControllers,
            "extension": setExtensions,
        }
        
        FilterUtils.extractUrlQueryOnMessage("post", url_data["rdkfilter"]);

        // Apply filters
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        if(FilterUtils.extracted_params.hasOwnProperty("name"))
            search_input.value = FilterUtils.extracted_params['name'];

        Object.keys(FilterUtils.extracted_params).map((key) => {
            if(key != "name") {
                editFilterFromUrl(
                    FilterUtils.extracted_params[key],
                    default_filter_map[key],
                    filter_set_map[key]
                );
            }
        });

        // Change init
        setInit(false);
        setFilterType("instant");
    };

    // onmessage for production version pairs with php
    onmessage = (event: any) => {
        //console.log(event.data)
        if(event.data.hasOwnProperty("rdkfilter")) {
            setupFilter({
                "rdkfilter": event.data.rdkfilter,
                "rdkinfo": event.data.rdkinfo
            });
        }
    }

    const editFilterFromUrl = (
        extracted_param: any, 
        default_filter: any,
        set_filter: any,
    ) => {
        if(Array.isArray(default_filter)) {
            const [min, max] = [
                parseFloat(extracted_param[0]),
                parseFloat(extracted_param[1])
            ];
            
            set_filter([
                min < default_filter[0] ? default_filter[0] : min,
                max > default_filter[1] ? default_filter[1] : max
            ]);
            setFilterType("instant");

        } else {
            let cloned_filter = structuredClone(default_filter);
            Object.keys(cloned_filter).map((entry) => {
                if(extracted_param.includes(entry.toLowerCase()))
                    cloned_filter[entry] = true;
            });

            set_filter(cloned_filter);
            setFilterType("instant");
        }
    }

    // filter methods
    const applyFilters = () => {
        tickApplyFilter = null;

        let filtered_list: any = PostsData.DATA_ALL; 
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        if(search_input.value.length > 0)
            filtered_list = LibraryUtils.searchWithItemsList("post", filtered_list) 

        for(const key in parameters) {
            let temp = FilterUtils.applyFiltersToList("post", key, parameters[key], filtered_list);

            if(Object.keys(temp).length > 0)
                filtered_list = temp;
        }

        filteredPostsCounts = FilterUtils.countCheckboxParameters("post", filtered_list);

        applyFiltersToUrl();
        setSortFilteredPosts(filtered_list);

        if (init) setFilterType("instant");
        else setFilterType("");
    };

    const applyFiltersSchedule = () => {
        if(tickApplyFilter != null) {
            clearTimeout(tickApplyFilter);
        };
        tickApplyFilter = setTimeout(applyFilters, 100);
    };

    const applyFiltersToUrl = () => {
        let hash_str = "";
        let query_symbol = "#filter?";
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        const filter_strings = {
            "brand": brands,
            "controller": controllers,
            "extension": extensions,
        }

        // name
        if(search_input.value.length > 0) {
            hash_str += query_symbol + "name=" + search_input.value.trim().toLowerCase().split(" ").join("+");
            query_symbol = "&";
        }

        // checkbox and slider
        Object.keys(filter_strings).map((string) => {
            let temp_hash = editUrlFilter(
                string, 
                filter_strings[string], 
                query_symbol
            );

            if(temp_hash != undefined) {
                hash_str += temp_hash;
                query_symbol = "&";
            }
        });

        // Only change hash when not init because
        // on init the hash is empty and it will reset
        // the hash to empty, this will make the saved urls
        // with filters not working properly
        if(!init) {
            window.location.hash = hash_str;
            window.parent.postMessage( { "hash": window.location.hash } );
        }
    };

    const editUrlFilter = (
        filter_string: string, 
        filter: any,
        query_symbol: string,
    ) => {
        // if(Array.isArray(filter)) {
        //     let default_ranges = {
        //         "mechanism_count": [StationData.robotMin, StationData.robotMax],
        //         "tool_count": [StationData.toolsMin, StationData.toolsMax],
        //         "object_count": [StationData.objectsMin, StationData.objectsMax],
        //     }

        //     if (
        //         filter[0] > default_ranges[filter_string][0] ||
        //         filter[1] < default_ranges[filter_string][1]
        //     )
        //         return query_symbol + filter_string + "=" + filter[0] + "-" + filter[1];

        // } else {
            let checked_values = [];
            Object.keys(filter).map((entry) => {
                if (filter[entry]) {
                    let temp_value = entry.trim().toLowerCase().split(" ").join("-");
                    if(temp_value == "ext.-axis") temp_value = "ext.axis"
                    checked_values.push(temp_value);
                }
            });
            if (checked_values.length > 0) {
                return query_symbol + filter_string + "=" + checked_values.join("+");
            }
        // }
    };

    const clearFilters = () => {
        setBrands(brandFilter);
        setControllers(controllerFilter);
        setExtensions(extensionFilter);
        
        setFilterType("instant");
    };

    const clearSearchParameters = () => {
        (document.getElementById("search-input") as HTMLInputElement).value = "";
       
        applyFilters();
        setFilterType("instant");
    };

    // Brand filter
    const handleInputChangeBrandFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_brand_filter = structuredClone(brands);
        new_brand_filter[e.currentTarget.value] = e.currentTarget.checked;

        setBrands(new_brand_filter);
        setFilterType("instant");
    };

    // Controller filter
    const handleInputChangeControllerFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_controller_filter = structuredClone(controllers);
        //console.log("target val", e.currentTarget.value);
        //console.log("target checked", e.currentTarget.checked);
        new_controller_filter[e.currentTarget.value] = e.currentTarget.checked;
        //console.log("new controllers", new_controller_filter)

        setControllers(new_controller_filter);
        setFilterType("instant");
    };

    // Extension filter
    const handleInputChangeExtensionFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_extension_filter = structuredClone(extensions);
        new_extension_filter[e.currentTarget.value] = e.currentTarget.checked;

        setExtensions(new_extension_filter);
        setFilterType("instant");
    };
    
    // Retrieve url filters
    // onload for local and direct production version
    React.useEffect(() => {
        if (init) {
            setupFilter(hash_message);
            setInit(false);
        }
    }, []);

    React.useEffect(() => {
        if(filterType == "delay")
            applyFiltersSchedule()

        else if(filterType == "instant")
            applyFilters();
    });

    const isSticky = useIsDesktop();

    return (
        <>
            {/* <div className="title sticky-top">
                {!hideTab && (
                    <Tab library={"post"} />
                )}
            </div> */}

            <div className="main-container container-fluid">
                <div className="row">
                    <div className="col col-12 col-sm-12 col-lg-3">
                        <div
                            className={`filter-form ${isSticky ? "sticky-top" : ""}`}
                            style={{ 
                                top: isSticky ? (window.Settings.LOCAL_BUILD ? "8rem" : "12.5rem") : undefined,
                                backgroundColor: "rgb(240, 240, 240)" 
                            }}
                        >
                            <div id="search-row">
                                <form id="search-bar">
                                    <input
                                        id="search-input"
                                        type="text"
                                        placeholder={t('library-headers.search-input')}
                                    />
                                    <div id="search-bar-action-btns">
                                        <button
                                            id="search-button"
                                            onClick={(e: React.MouseEvent) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                applyFilters();
                                            }}
                                        >
                                            <img
                                                width="auto"
                                                height="18rem"
                                                alt="Search"
                                                src={window.Paths.POST_LIB_ASSETS_CDN + "magnifier.png"}
                                            />
                                        </button>
                                    </div>
                                </form>
                            </div>

                            <div className="section-top">
                                <a
                                    className="btn center-block"
                                    style={{ marginLeft: ".5rem" }}
                                    onClick={(e: React.MouseEvent) => {
                                        clearFilters();
                                        clearSearchParameters();
                                    }}
                                >
                                    {t('library-overlays.clearFiltersBtn')}
                                </a>
                            </div>
                            <div className="filters">
                                <Filter
                                    type = "brands"
                                    title = "filters-posts.brand"
                                    data = {brands}
                                    counts = {filteredPostsCounts}
                                    handler = {handleInputChangeBrandFilter}
                                    first = {true}
                                />

                                <Filter
                                    type = "controllers"
                                    title = "filters-posts.controller"
                                    data = {controllers}
                                    counts = {filteredPostsCounts}
                                    handler = {handleInputChangeControllerFilter}
                                    first = {false}
                                />

                                <Filter
                                    type = "extensions"
                                    title = "filters-posts.extension"
                                    data = {extensions}
                                    counts = {filteredPostsCounts}
                                    handler = {handleInputChangeExtensionFilter}
                                    first = {false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col col-12 col-sm-12 col-lg-9">
                        <PostLib
                            noRobotsMessage = {noRobotsMessage}
                            sortFilteredPosts = {sortFilteredPosts}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
